export type UpdateIFDefinitionsResponse = {
  /**
   * The results of this update_if_definitions response body.
   */
  result: Result[];
};

export type Result = {
  index: number;
  ifReqId: string;
  messageList: Message[];
  errorColumnList: string[];
};

export type Message = {
  val: string;
  col: string[];
};
